    import moment from "moment";

    export const truncateWords = (text = "", wordLimit = 3) => {
        const words = text.trim().split(/\s+/).filter(Boolean);
        if (words.length <= wordLimit) return text;
        return `${words.slice(0, wordLimit).join(" ")}...`;
    };
    
    export const truncateWordsDynamic = (text = "", containerWidth) => {
        // Aproximado: cada carácter ocupa ~8px en font-bold text-l
        // Dejar margen para padding (ml-2 = 0.5rem = 8px)
        const availableWidth = containerWidth - 16;
        const avgCharWidth = 7.5;
        const maxChars = Math.floor(availableWidth / avgCharWidth);
        
        if (text.length <= maxChars) return text;
        
        const words = text.trim().split(/\s+/).filter(Boolean);
        let result = "";
        for (let word of words) {
            if ((result + word).length + 3 <= maxChars) {
                result = result ? `${result} ${word}` : word;
            } else {
                break;
            }
        }
        return result ? `${result}...` : text.substring(0, maxChars) + "...";
    };
    export const formatRelativeShort = (date) => {
        const now = moment();
        const target = moment(date).endOf('day');
        const diffMs = target.diff(now);
        const isOverdue = diffMs < 0;
        const duration = moment.duration(Math.abs(diffMs));
        const prefix = isOverdue ? "-" : "";
        if (duration.asDays() >= 1) {
            return `${prefix}${Math.round(duration.asDays())} d`;
        }
        if (duration.asHours() >= 1) {
            return `${prefix}${Math.round(duration.asHours())} hs`;
        }
        return `${prefix}${Math.max(1, Math.round(duration.asMinutes()))} m`;
    };

        export const getContrastColor = (hexColor) => {
        // Convertir hex a RGB
        const hex = hexColor.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        
        // Calcular luminancia usando fórmula WCAG
        const luminancia = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        
        // Si es claro, retornar negro; si es oscuro, retornar blanco
        return luminancia > 0.5 ? '#000000' : '#ffffff';
    };

    export const taskTemplateOptions = [
        { value: '', label: 'Template' },
        { value: 'clasica', label: 'Clásica' },
        { value: 'story', label: 'Story' },
        { value: 'bug', label: 'Bug' }
    ];

    export const taskTemplateMarkdown = {
        clasica: `## Objetivo

Describe el objetivo principal de la tarea.

## Alcance

- Alcance 1
- Alcance 2

## Entregables

- Entregable 1
- Entregable 2

## Criterios de éxito

- Criterio 1
- Criterio 2`,
        story: `## Historia

Como **[tipo de usuario]**, quiero **[objetivo]** para **[beneficio]**.

## Criterios de aceptación

- [ ] Criterio 1
- [ ] Criterio 2

## Notas

- Nota 1
- Nota 2`,
        bug: `## Resumen

Describe el error encontrado.

## Comportamiento actual

Qué está ocurriendo actualmente.

## Comportamiento esperado

Qué debería ocurrir.

## Pasos para reproducir

1. Paso 1
2. Paso 2
3. Paso 3

## Evidencia

- Capturas / logs / enlaces relevantes`
    };

    export const projectTemplateOptions = [
        { value: '', label: 'Template' },
        { value: 'clasica', label: 'Clásica' },
        { value: 'roadmap', label: 'Roadmap' },
        { value: 'investigacion', label: 'Investigación' },
        { value: 'lanzamiento', label: 'Lanzamiento' }
    ];

    export const projectTemplateMarkdown = {
        clasica: `## Descripción

Describe el proyecto de forma breve.

## Objetivo

Qué se busca lograr con este proyecto.

## Alcance

- Incluye:
- No incluye:

## Entregables

- Entregable 1
- Entregable 2

## Criterios de éxito

- Criterio 1
- Criterio 2`,
        roadmap: `## Visión general

Resumen del proyecto y su propósito.

## Hitos

1. Hito 1 - Fecha estimada
2. Hito 2 - Fecha estimada
3. Hito 3 - Fecha estimada

## Dependencias

- Dependencia 1
- Dependencia 2

## Riesgos

- Riesgo 1
- Riesgo 2`,
        investigacion: `## Problema a investigar

Define la pregunta principal.

## Hipótesis

Qué se espera validar.

## Metodología

- Método 1
- Método 2

## Fuentes

- Fuente 1
- Fuente 2

## Resultados esperados

- Resultado 1
- Resultado 2`,
        lanzamiento: `## Resumen de lanzamiento

Descripción del release.

## Checklist previo

- [ ] QA completo
- [ ] Aprobación de stakeholders
- [ ] Documentación actualizada

## Plan de despliegue

1. Paso 1
2. Paso 2
3. Paso 3

## Plan de rollback

Pasos para revertir en caso de incidente.`
    };

    export const subtaskTemplateOptions = [
        { value: '', label: 'Template' },
        { value: 'clasica', label: 'Clásica' },
        { value: 'checklist', label: 'Checklist' },
        { value: 'investigacion', label: 'Investigación' },
        { value: 'bloqueada', label: 'Bloqueada' }
    ];

    export const subtaskTemplateMarkdown = {
        clasica: `## Descripción

Descripción breve de la subtarea.

## Detalles

- Detalle 1
- Detalle 2`,
        checklist: `## Descripción

Subtarea orientada a verificación.

## Checklist

- [ ] Punto 1
- [ ] Punto 2
- [ ] Punto 3

## Resultado esperado

Qué debe quedar validado al terminar.`,
        investigacion: `## Descripción

Tema a investigar en esta subtarea.

## Detalles

- Pregunta principal:
- Hipótesis:
- Fuentes:

## Hallazgos

- Hallazgo 1
- Hallazgo 2`,
        bloqueada: `## Descripción

Subtarea actualmente bloqueada.

## Detalles

- Motivo del bloqueo:
- Dependencia pendiente:
- Responsable:

## Próximo paso

Acción para destrabar la subtarea.`
    };
